import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useU2106ProfileHandlers } from '../hooks/useU2106ProfileHandlers';
import U2106ChangePasswordFields from './U2106ChangePasswordFields';

/** Garde SSO uniquement — le formulaire vit dans un autre fichier (anti-inlining Compiler). */
const U2106ChangePasswordForm: React.FC = () => {
  const navigate = useNavigate();
  const { loadProfile } = useU2106ProfileHandlers();
  const [ssoGateChecked, setSsoGateChecked] = useState(false);

  useEffect(() => {
    let cancelled = false;
    loadProfile().then((profile) => {
      if (cancelled) {
        return;
      }
      if (profile?.ssoEnabled === true) {
        navigate('/U2106/profile', { replace: true });
        return;
      }
      setSsoGateChecked(true);
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- garde SSO une fois au montage
  }, []);

  if (!ssoGateChecked) {
    return null;
  }

  return <U2106ChangePasswordFields />;
};

export default U2106ChangePasswordForm;
